module.exports = __webpack_public_path__ + "static/media/additionalQuestions.81851a5e.png";